
// reverse years in select on product
(function () {
    
   
    document.addEventListener("DOMContentLoaded", function() {
      const select = document.getElementById("rok-produkcji");
      if (select) {
          const options = Array.from(select.options).slice(1); // Exclude the first option
  
          options.reverse();
  
          // Clear the select element, but keep the first option
          select.innerHTML = `<option value="" >${select.dataset.text}</option>`;
          console.log(select)
          
          // Append the reversed options back to the select element
          options.forEach(option => select.appendChild(option));
      }
    });
  })();
  // reverse years in select on product


// swiper cart notification

(function () {
    if (document.querySelector('.related_product__list')) {
        const cartSwiper = new Swiper('.related_product__list', {
            spaceBetween: 10,
            slidesPerView: 2,
            // If we need pagination
          
            // Navigation arrows
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                800: {
                  slidesPerView: 2
                },
                1024: {
                  slidesPerView: 3
                },
              }
          });
    }
})();
// swiper cart notification

// toggle galleries on change mats type inputs
(function () {
    const thumbnailItems = document.querySelectorAll('.thumbnail-slider')
    thumbnailItems.forEach((el) => {
      el.querySelector('.thumbnail').click()
      el.closest('media-gallery').classList.add('show')
    })
    const radioButtons = document.querySelectorAll('product-info input[name="Rodzaj dywaników"]');
    if (radioButtons) {
      const mediaGalleryWithoutEdges = document.querySelector('.product__media_without_edges');
      const mediaGalleryWithEdges = document.querySelector('.product__media_with_edges');
  
      const scrollToTop = () => {
        if (window.innerWidth <= 767) {
          window.scrollTo(0, 0);
        }
      }
  
      const clickSecondImage = (value) => {
        if (value === "3D BEZ RANTÓW") {
          mediaGalleryWithoutEdges.querySelectorAll('.thumbnail')[1].click()
        }
        if (value === "3D Z RANTAMI") {
          mediaGalleryWithEdges.querySelectorAll('.thumbnail')[1].click()
        }
      }
  
      radioButtons.forEach((radio) => {
        if (radio.checked && radio.value === "3D BEZ RANTÓW") {
          mediaGalleryWithoutEdges.classList.add('active')
          mediaGalleryWithEdges.classList.remove('active')
        } else if (radio.checked && radio.value === "3D Z RANTAMI") {
          mediaGalleryWithoutEdges.classList.remove('active')
          mediaGalleryWithEdges.classList.add('active')
        }
        radio.addEventListener("change", function () {
          scrollToTop()
          if (this.value === "3D BEZ RANTÓW") {
            mediaGalleryWithoutEdges.classList.add('active')
            mediaGalleryWithEdges.classList.remove('active')
            clickSecondImage(radio.value)
  
          } else if (this.value === "3D Z RANTAMI") {
            mediaGalleryWithoutEdges.classList.remove('active')
            mediaGalleryWithEdges.classList.add('active')
            clickSecondImage(radio.value)
          }
  
        });
      });
    }
  })();


// toggle size product config mobile
(function () {
    const toggler = document.querySelector('.product__config__toggle_size')
    const container = document.querySelector('.sticky_config_price')
    const image = document.querySelector('.product__config_image_image')
    if (toggler) {
      console.log(toggler)
      
      toggler.addEventListener('click', () => {
        console.log(234)
        toggler.classList.toggle('active')
        container.classList.toggle('wide')
        container.removeAttribute('style')
      })
      image.addEventListener('click', () => {
        console.log(444)
        toggler.classList.toggle('active')
        container.classList.toggle('wide')
        container.removeAttribute('style')
      })
    }
  })();
  // toggle size product config mobile


// bounce config image mobile after change option
(function () {
    const image = document.querySelector('.sticky_config_price .product__config_image--mobile img')
    const options = document.querySelectorAll('.product__info-wrapper [data-name="Rodzaj dywaników"] input')
  
    if (image) {
      options.forEach(el => {
        el.addEventListener('change', () => {
          image.classList.add('animate__bounce')
          setTimeout(() => {
            
            image.classList.remove('animate__bounce')
          }, 1000);
        })
      })   
    }
  })();
  // bounce config image mobile after change option


// product sticky price
(function () {
    const mainPriceElement = document.querySelector('.main_price');
    const stickyConfigPriceElement = document.querySelector('.sticky_config_price');
    const productOptions = document.querySelectorAll('.product-form__input input');
  
    if (stickyConfigPriceElement && window.innerWidth > 767) {
        // Создаем наблюдатель
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
            if (!entry.isIntersecting) {
                // Если элемент не виден, добавляем класс active
                stickyConfigPriceElement.classList.add('active');
            } else {
                // Если элемент виден, убираем класс active
                stickyConfigPriceElement.classList.remove('active');
            }
            });
        });
        
        window.addEventListener('load', () => {
            stickyConfigPriceElement.style.width = stickyConfigPriceElement.offsetWidth + 1 + 'px'
        })
        
        // Начинаем наблюдение за основным элементом
        if (mainPriceElement) {
            observer.observe(mainPriceElement);
        }
    } else if (stickyConfigPriceElement) {
      stickyConfigPriceElement.classList.add('active');
    }
  
  })();
  // product sticky price


// Click on the partial payment button in the product card
document.addEventListener('DOMContentLoaded', function () {
    const button = document.getElementById('partial-paymant__btn--add')
  
    if (button) {
      button.addEventListener('click', function () {
  
        waitForElement('.product-form__submit', function () {
          const productFormSubmitBtn = document.querySelector('.product-form__submit');
    
          if (productFormSubmitBtn) {
            productFormSubmitBtn.click();
          }
        });
      });
    }
    
  });
  
  function waitForElement(selector, callback) {
    const element = document.querySelector(selector);
  
    if (element) {
      callback();
    } else {
      requestAnimationFrame(function () {
        waitForElement(selector, callback);
      });
    }
  }